import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ServiceBenefits = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);

      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      <div>
        <section className="bg-gray-100/50 py-20/50 lg:py-28 max-md:pt-[120px] max-md:pb-[100px]">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

            {/* Section Header */}
            <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
              <div>
                {/* Badge */}
                <div className="inline-flex mb-6 items-center gap-2 rounded-full border border-orange-300 bg-orange-100 px-4 py-2">
                  <span className="relative flex h-2 w-2">

                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-orange-400 opacity-75" />
                    <span className="relative inline-flex h-2 w-2 rounded-full bg-orange-500" />
                  </span>
                  <span className="text-sm font-medium text-orange-600">
                    Benefits Explained
                  </span>
                </div>
                <h2 className="font-display text-3xl font-bold text-gray-900 lg:text-4xl">
                  Browse our Services
                </h2>
                <p className="mt-2 text-gray-600">
                  Say goodbye to out-of-pocket medical expenses
                </p>
              </div>
            </div>

            <div className="mt-12 grid gap-6 grid-cols-1">
              <div
                className="card-hover group rounded-2xl border border-gray-200 bg-white p-6" id="tele-consultation"
              >
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-primary-100">
                  <img src="/assets/icons/tele-consult.svg" alt="Tele consultation" />
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold text-gray-900 group-hover:text-primary-600">
                  Tele Consultation
                </h3>
                <p className="mt-2 line-clamp-3 text-sm text-gray-600">
                  Connect with qualified and experienced doctors through secure tele-consultation from the comfort of your home. Our medical experts hold recognized degrees such as MBBS, MD, and other certified specializations, ensuring trusted and professional healthcare guidance.
                </p>
                <ul className="mt-2 text-sm text-gray-600 list-disc pl-[16px]">
                  <li>Consultation with qualified and verified doctors</li>
                  <li>Doctors with 25+ years of medical experience</li>
                  <li>Support in multiple languages for better communication</li>
                  <li>Convenient online consultations anytime, anywhere</li>
                  <li>Personalized medical advice and treatment guidance</li>
                </ul>
                <div className="mt-4 flex gap-2 items-center flex-wrap">
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      General Physician
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      Ayurvedic
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      Homeopathy
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      Gynaecologist
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      Pediatric
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      Gastroenterologist
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      ENT
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      Sexologist
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      Dental
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      Orthopedic
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      Dietician
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      Diabetologist
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      Rheumatology
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      Dermatologist
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      Cardiologist
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      Pulmonology
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      Physiotherapy
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      Urologist
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      Neurologist
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#00726030] bg-[#00726010] px-4 py-2">
                    <span className="text-sm font-medium text-[#007260]">
                      Cough and Fever
                    </span>
                  </div>
                </div>
              </div>

              <div
                className="card-hover group rounded-2xl border border-gray-200 bg-white p-6" id="diagnostics"
              >
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-accent-100">
                  <img src="assets/icons/diagnostics.svg" alt="Diagnostics" />
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold text-gray-900 group-hover:text-primary-600">
                  Diagnostics
                </h3>
                <p className="mt-2 line-clamp-3 text-sm text-gray-600">

                  Get access to reliable and accurate diagnostic services through our trusted network of certified laboratories and diagnostic centers. From routine health tests to advanced diagnostics, our partnered labs follow strict quality standards to ensure precise and dependable results.
                </p>
                <ul className="mt-2 text-sm text-gray-600 list-disc pl-[16px]">
                  <li>Access to accredited and trusted diagnostic laboratories</li>
                  <li>Wide range of pathology and radiology tests available</li>
                  <li>High-precision equipment for accurate test results</li>
                  <li>Convenient test booking with quick report delivery</li>
                  <li>Home sample collection available for selected tests</li>
                </ul>
                <div className="mt-4 flex gap-2 items-center flex-wrap">
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#C6502930] bg-[#C6502910] px-4 py-2">
                    <span className="text-sm font-medium text-[#C65029]">
                      Redcliffe Labs
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#C6502930] bg-[#C6502910] px-4 py-2">
                    <span className="text-sm font-medium text-[#C65029]">
                      Healthians
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#C6502930] bg-[#C6502910] px-4 py-2">
                    <span className="text-sm font-medium text-[#C65029]">
                      Thyrocare
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#C6502930] bg-[#C6502910] px-4 py-2">
                    <span className="text-sm font-medium text-[#C65029]">
                      Orange Health Labs
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#C6502930] bg-[#C6502910] px-4 py-2">
                    <span className="text-sm font-medium text-[#C65029]">
                      Metropolis
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#C6502930] bg-[#C6502910] px-4 py-2">
                    <span className="text-sm font-medium text-[#C65029]">
                      Toothsi
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#C6502930] bg-[#C6502910] px-4 py-2">
                    <span className="text-sm font-medium text-[#C65029]">
                      Beato
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#C6502930] bg-[#C6502910] px-4 py-2">
                    <span className="text-sm font-medium text-[#C65029]">
                      Pathkind
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#C6502930] bg-[#C6502910] px-4 py-2">
                    <span className="text-sm font-medium text-[#C65029]">
                      Tata 1mg
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#C6502930] bg-[#C6502910] px-4 py-2">
                    <span className="text-sm font-medium text-[#C65029]">
                      Manipal Hospitals
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#C6502930] bg-[#C6502910] px-4 py-2">
                    <span className="text-sm font-medium text-[#C65029]">
                      Agilus Diagnostics
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#C6502930] bg-[#C6502910] px-4 py-2">
                    <span className="text-sm font-medium text-[#C65029]">
                      Aarthi Scans & Labs
                    </span>
                  </div>
                </div>
              </div>

              <div
                className="card-hover group rounded-2xl border border-gray-200 bg-white p-6" id="consultation"
              >
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-pink-100">
                  <img src="assets/icons/consultation.svg" alt="Consultation" />
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold text-gray-900 group-hover:text-primary-600">
                  Consultation
                </h3>
                <p className="mt-2 line-clamp-3 text-sm text-gray-600">
                  Visit experienced and qualified doctors for face-to-face medical consultations at trusted clinics and hospitals within our healthcare network. Receive thorough evaluations, accurate diagnoses, and personalized treatment guidance through direct interaction with medical professionals.
                </p>
                <ul className="mt-2 text-sm text-gray-600 list-disc pl-[16px]">
                  <li>Face-to-face consultation with qualified and verified doctors</li>
                  <li>Access to experienced specialists across multiple fields</li>
                  <li>Doctors with 25+ years of clinical experience</li>
                  <li>Comprehensive health evaluation and accurate diagnosis</li>
                  <li>Easy appointment booking at nearby clinics and hospitals</li>
                </ul>
                <div className="mt-4 flex gap-2 items-center flex-wrap">
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      General Physician
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      Pediatrics & Nutritionist
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      Dietician
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      Orthopaedics
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      Diabetologist
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      Dermatologist
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      Neurologist
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      Dental
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      ENT
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      Ayurveda
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      Cardiologist
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      Gastroenterology
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      General Surgery
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      Gynaecologist
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      Mental Health
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      Oncologist
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      Ophthalmology
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      Physiotheraphy
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      Plastic Surgery
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-[#DB277730] bg-[#DB277710] px-4 py-2">
                    <span className="text-sm font-medium text-[#DB2777]">
                      Pulmonology
                    </span>
                  </div>
                </div>
              </div>

              <div
                className="card-hover group rounded-2xl border border-gray-200 bg-white p-6" id="mental-wellness"
              >
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-cyan-100">
                  <img src="assets/icons/mental-wellness.svg" alt="Mental Wellness" />
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold text-gray-900 group-hover:text-primary-600">
                  Mental Wellness
                </h3>
                <p className="mt-2 line-clamp-3 text-sm text-gray-600">
                  Access professional mental health support from qualified psychologists, counselors, and wellness experts dedicated to helping you manage stress, anxiety, and emotional well-being. Our mental wellness services focus on providing a safe and supportive environment for improving overall mental health.
                </p>
                <ul className="mt-2 text-sm text-gray-600 list-disc pl-[16px]">
                  <li>Consultation with qualified psychologists and certified counselors</li>
                  <li>Support for stress, anxiety, and emotional well-being</li>
                  <li>Confidential and secure counseling sessions</li>
                  <li>Personalized mental health guidance and therapy support</li>
                  <li>Flexible appointments for convenient access to care</li>
                </ul>
              </div>

              <div
                className="card-hover group rounded-2xl border border-gray-200 bg-white p-6" id="vitals"
              >
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-violet-100">
                  <img src="assets/icons/face-scan.svg" alt="Face Scan" />
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold text-gray-900 group-hover:text-primary-600">
                  Vitals via Face Scan
                </h3>
                <p className="mt-2 line-clamp-3 text-sm text-gray-600">
                  Measure key health indicators instantly using advanced AI-powered face scanning technology combined with basic health inputs like height and weight. This quick and non-invasive check provides insights into your vital health parameters without the need for medical equipment.
                </p>
                <ul className="mt-2 text-sm text-gray-600 list-disc pl-[16px]">
                  <li>AI-powered face scan to estimate vital health parameters</li>
                  <li>Non-invasive and contactless health assessment</li>
                  <li>Instant results within seconds</li>
                  <li>Uses facial signals along with height and weight inputs</li>
                  <li>Helps track basic health indicators conveniently</li>
                </ul>
              </div>

              <div
                className="card-hover group rounded-2xl border border-gray-200 bg-white p-6" id="chat"
              >
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-amber-100">
                  <svg
                    className="h-7 w-7 text-amber-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
                    ></path>
                  </svg>
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold text-gray-900 group-hover:text-primary-600">
                  Chat With Experts
                </h3>
                <p className="mt-2 line-clamp-3 text-sm text-gray-600">
                  Get quick guidance and reliable health advice by chatting directly with qualified healthcare experts. Whether you have a health query, need lifestyle advice, or want clarification about a medical concern, our experts are available to assist you.
                </p>
                <ul className="mt-2 text-sm text-gray-600 list-disc pl-[16px]">
                  <li>Chat directly with qualified healthcare experts</li>
                  <li>Get quick answers to everyday health questions</li>
                  <li>Guidance on lifestyle, nutrition, and preventive care</li>
                  <li>Convenient text-based support anytime, anywhere</li>
                  <li>Safe and confidential conversations with professionals</li>
                </ul>
              </div>

              <div
                className="card-hover group rounded-2xl border border-gray-200 bg-white p-6" id="video-consultation"
              >
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-red-100">
                  <img src="assets/icons/video-consult.svg" alt="Video Consult" />
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold text-gray-900 group-hover:text-primary-600">
                  Video Consultation
                </h3>
                <p className="mt-2 line-clamp-3 text-sm text-gray-600">
                  Consult with qualified and experienced doctors through secure video consultations without visiting a clinic. Connect face-to-face with medical professionals from the comfort of your home and receive trusted medical guidance and treatment advice.
                </p>
                <ul className="mt-2 text-sm text-gray-600 list-disc pl-[16px]">
                  <li>Secure video consultations with qualified doctors</li>
                  <li>Face-to-face interaction for better medical assessment</li>
                  <li>Doctors with 25+ years of clinical experience</li>
                  <li>Convenient consultations from home or anywhere</li>
                  <li>Personalized medical advice and treatment guidance</li>
                </ul>
              </div>

              <div
                className="card-hover group rounded-2xl border border-gray-200 bg-white p-6" id="naturopathy"
              >
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-emerald-100">
                  <img src="assets/icons/naturopathy.svg" alt="Naturopathy" />
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold text-gray-900 group-hover:text-primary-600">
                  Naturopathy
                </h3>
                <p className="mt-2 line-clamp-3 text-sm text-gray-600">
                  Experience holistic health support through natural therapies that focus on improving the body’s ability to heal and maintain balance. Naturopathy promotes wellness through natural practices, lifestyle improvements, and preventive health approaches.
                </p>
                <ul className="mt-2 text-sm text-gray-600 list-disc pl-[16px]">
                  <li>Consultation with experienced naturopathy practitioners</li>
                  <li>Focus on natural and holistic wellness approaches</li>
                  <li>Guidance on lifestyle, diet, and natural therapies</li>
                  <li>Support for improving overall health and well-being</li>
                  <li>Personalized wellness plans based on individual needs</li>
                </ul>
              </div>
            </div>

          </div>
        </section>
      </div>


    </>
  );
};

export default ServiceBenefits;
